import { DateTime } from "luxon";

const formatDateToDD = (date: string) => {
  return DateTime.fromISO(date, { zone: "UTC" }).toFormat("MMM d, yyyy");
};

export default formatDateToDD;
